import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (TemplatesPage + API) eager zu laden. Die Seite kommt über die Lazy-Route
 * in App.tsx.
 */
const manifest: SkillManifest = {
  key: 'templates',
  name: 'Projekt-Vorlagen',
  description: 'Wiederverwendbare Projekt-Defaults pflegen — eigene Listenseite unter /templates.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.PROJECT_CREATE],
  enabledByDefault: true,
};

export const templatesSkill: FrontendSkill = {
  manifest,
};
